import { TableRow } from '@mui/material';
import { styled } from '@mui/system';
import { style } from '@/styles/globals';

export const StyledTableRow = styled(TableRow)(() => ({
  display: 'flex',
  '&:nth-of-type(odd)': {
    backgroundColor: style.color.white3,
  },
}));
